import {styled, forBrands, Theme, CSSObject} from "@core-ui/react-stitch";

interface CardNameProps {
  bolder?: boolean;
  enabledFeatures?: Record<string, boolean>;
  displayAsRow?: boolean;
}

const gapStyles = (): CSSObject => ({
  fontSize: "0.8rem",
});

const oldNavyStyles = (): CSSObject => ({
  fontSize: "0.8rem",
});

const bananaRepublicStyles = (
  theme: Theme,
  bolder: boolean,
  enabledFeatures: Record<string, boolean>
): CSSObject => {
  const isNewBrFontEnabled = enabledFeatures["enable-new-br-fonts"];
  return {
    ...(isNewBrFontEnabled ? theme.brandFontAlt : theme.brandFont),
    color: isNewBrFontEnabled ? theme.color.b2 : theme.color.g2,
    fontWeight: bolder ? "bold" : "normal",
    fontSize: isNewBrFontEnabled ? "0.85rem" : "0.8125rem",
  };
};

const athletaStyles = (): CSSObject => ({
  fontVariantLigatures: "none",
  fontSize: "0.8125rem",
  letterSpacing: "1px",
});

const defaultStyles = (): CSSObject => ({
  fontSize: "1rem",
  lineHeight: 1.125,
  letterSpacing: "0.5px",
});

const brandStyles = (
  theme: Theme,
  bolder: boolean,
  enabledFeatures: Record<string, boolean>
): CSSObject =>
  forBrands(theme, {
    gap: gapStyles,
    gapfs: gapStyles,
    br: bananaRepublicStyles(theme, bolder, enabledFeatures),
    brfs: bananaRepublicStyles(theme, bolder, enabledFeatures),
    on: oldNavyStyles,
    at: athletaStyles,
    default: defaultStyles,
  }) as CSSObject;

const lineClamp: CSSObject = {
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const CardName = styled.div<CardNameProps>(
  ({theme, bolder = false, enabledFeatures = {}, displayAsRow = false}) => ({
    ...theme.brandFont,
    color: theme.color.g2,
    lineHeight: 1.4,
    textTransform: "none",
    fontWeight: bolder ? "bold" : "normal",
    ...brandStyles(theme, bolder, enabledFeatures),
    ...(displayAsRow ? lineClamp : {}),
  })
);

export default CardName;
